import React from "react";

import Header from "../../header";
import Banner from ".././Banner";
import SubNav from ".././SubNav";
import Footer from "../../Footer";

// const stableandintelligent = require("../../../assets/icons-pack/7.2 Web Application Firewall/ic_01_stableandintelligent.svg");
// const operationorientated = require("../../../assets/icons-pack/7.2 Web Application Firewall/ic_02_operationorientated.svg");
// const synergistic = require("../../../assets/icons-pack/7.2 Web Application Firewall/ic_03_synergistic.svg");

const WebAppFirewall = () => {
    const heading = `WEB APPLICATION FIREWALL`;
    const details = `Designed to keep your website and applications secure.`;

    // const newLocal = () => ();
    const overview = [
        `Web Application Firewall (WAF) protects your website servers against intrusions. DETASAD provides a combination of Application Delivery Controller and Web Application Firewall. WAF uses deep learning algorithms to filter out malicious requests and common attacks, such as SQL injection and XSS, and prevent attacks to your application availability, security, or resources. DETASAD’s Marketplace offers products which provide WAF functionality.  Visit the following link and get equipped with state-of-the-art Web Application Firewalls.`
    ];
    
    const links = `http://10.81.1.40/services/web_application_firewall`

    const functions = [
        [
            `Rapid and Stable`,
            [`Enables optimal access; supports resolution on the cloud; deploys within seconds.`]
        ],
        [
            `Application Oriented`,
            [`Allows you to define your own application-specific protection rules to accurately intercept attacks and reduce misreports, perfect for various industries.`]
        ],
        [
            `Collaborative`,
            [`Supports automatic upgrade on the cloud; detects potential threats and sets up multi-dimensional defense systems in collaboration with other security services.`]
        ]
    ];
    return (
        <div>
            <Header />
            <Banner heading={heading} details={details} className="bg-security"/>
            <SubNav overview={overview} functions={functions} links={links}/>
            <Footer />
        </div>
    );
};

export default WebAppFirewall;
